import { Translation } from '../../domain/Translation';

export const translate = (translations: Translation[], alias: string) => {
  return (
    translations.find((translation) => translation.alias === alias)?.value ??
    alias
  );
};

export const translateError = (
  translations: Translation[],
  error: string | string[],
) => {
  return typeof error === 'string'
    ? translate(translations, error)
    : error.map((err) => translate(translations, err)).join(', ');
};
